exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._7jLBY{margin:25px 0 50px}._7jLBY ._3xQY0{margin:25px 0;text-align:center}._7jLBY ._3xQY0 img{margin:0 auto 35px}._7jLBY ._3xQY0 h3{margin:0;font-family:Gotham Rounded A,Gotham Rounded B,HelveticaNeue-light,Arial,sans-serif;font-style:normal;font-weight:400;font-size:24px;font-size:1.5rem}._7jLBY ._3xQY0 h4{margin-top:35px;margin-bottom:5px;font-family:Gotham SSm A,Gotham SSm B,HelveticaNeue-light,Arial,sans-serif;font-style:normal;font-weight:700}._7jLBY ._3xQY0 p{margin-bottom:15px}", ""]);

// exports
exports.locals = {
	"products": "_7jLBY",
	"product": "_3xQY0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"minimize":true,"discardComments":{"removeAll":true},"localIdentName":"[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/routes/home/products/Products.scss
// module id = 754
// module chunks = 2